import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../../Calculators/RangeSplitter";

export default function Summary_2({ item, isSub }) {
  //const isHtml = item.scale.isHtml;

  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scale.ranges);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  return (
    <Row style={{ marginBottom: "1px", paddingLeft: "10px" }}>
      <Col className={"align-content-center"} xs={4}>
        <Row className={isSub ? "sub-name-style-pdf-thin" : "name-style-pdf-thin"}>
          <Col className={"align-content-center"}> {item.name}</Col>
          <Col xs={"auto"} className={"align-content-center px-0"}>
            <Row className={"justify-content-center  mx-0"}>
              <div
                className={"_flex-center " + (isSub ? "sub-score-style-pdf-thin" : "score-style-pdf-thin")}
                style={{ width: "48px", whiteSpace: "nowrap" }}
              >
                {elementScore} {isSub ? "%" : ""}
              </div>
            </Row>
          </Col>
        </Row>
      </Col>

      <Col xs={8} className={"align-content-center"}>
        <Row>
          {splitRanges.beforeHitRangeList.map((range, i) => {
            return (
              <Col key={"b" + i} className={" px-0 align-content-center"}>
                <ProgressBar
                  className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
                  style={{ height: isSub ? "6px" : "9px", margin: "0 1px" }}
                  now={100}
                ></ProgressBar>
              </Col>
            );
          })}
          <Col className={" p-0 align-content-center"}>
            <ProgressBar
              className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
              style={{ height: isSub ? "6px" : "9px", margin: "0 1px" }}
              now={filledPart}
            ></ProgressBar>
          </Col>
          {splitRanges.afterHitRangeList.map((range, i) => {
            return (
              <Col key={"a" + i} className={" px-0 align-content-center"}>
                <ProgressBar
                  className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
                  style={{ height: isSub ? "6px" : "9px", margin: "0 1px" }}
                  now={0}
                ></ProgressBar>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
